import moment from 'moment';
import { AREAS } from '@/pages/intelligence/components/TeaSelector/AreaSelect/constants';
import {
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 组合下拉筛选器
  COMPOSED_SELECT as FILTER_COMPOSED_SELECT,
  // 单选、多选国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
  // 多选区域筛选器
  MULTIPLE_AREA_SELECT as FILTER_MULTIPLE_AREA_SELECT,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  getPCConsolePlatformsOptions,
  getPCConsoleTopsOptionsMapping,
} from '@/pages/intelligence/_config/storeRank/utils';
import {
  CONSOLE_PLATFORM_PLAYSTATION,
  CONSOLE_STORE_RANK_TOPS_MAPPING,
} from '@/pages/intelligence/_config/storeRank/config';

const PLATFORMS_OPTIONS = getPCConsolePlatformsOptions('console');
const PLATFORMS_TOPS_OPTIONS_MAPPING = getPCConsoleTopsOptionsMapping('console');
const INITIAL_PLATFORM = CONSOLE_PLATFORM_PLAYSTATION;
const INITIAL_SHOP = CONSOLE_STORE_RANK_TOPS_MAPPING?.[INITIAL_PLATFORM]?.[0] ?? CONSOLE_PLATFORM_PLAYSTATION;

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST_MAP = {
  RANGE_TIME: {
    key: FILTER_RANGE_TIME,
    showSelectType: true,
    typeList: ['date'],
    type: FILTER_RANGE_TIME,
    visible: 1,
    calendarType: 'date',
  },
  COMPOSED_SELECT: {
    key: FILTER_COMPOSED_SELECT,
    type: FILTER_COMPOSED_SELECT,
    visible: 1,
    isTranslate: true,
    parentOptions: PLATFORMS_OPTIONS,
    childOptionsMap: PLATFORMS_TOPS_OPTIONS_MAPPING,
  },
  COMPOSED_COUNTRY_SELECT: {
    key: FILTER_COMPOSED_COUNTRY_SELECT,
    type: FILTER_COMPOSED_COUNTRY_SELECT,
    visible: 2,
    disabled: false,
    isAll: false,
    options: [],
  },
  MULTIPLE_AREA_SELECT: {
    key: FILTER_MULTIPLE_AREA_SELECT,
    type: FILTER_MULTIPLE_AREA_SELECT,
    visible: 2,
  },
};

// 筛选器默认值
export const FILTER_DEFAULT_VALUE = {
  [FILTER_RANGE_TIME]: {
    type: 'date',
    value: [moment().subtract(30, 'd'), moment().subtract(1, 'd')],
  },
  [FILTER_COMPOSED_SELECT]: {
    value: {
      parent: INITIAL_PLATFORM,
      child: INITIAL_SHOP,
    },
  },
  [FILTER_COMPOSED_COUNTRY_SELECT]: {
    value: {
      type: 'multiple',
      countries: [],
    },
  },
  [FILTER_MULTIPLE_AREA_SELECT]: {
    value: AREAS,
  },
};

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST = [
  FILTER_DEFAULT_INPUT_LIST_MAP.RANGE_TIME,
  FILTER_DEFAULT_INPUT_LIST_MAP.COMPOSED_SELECT,
  FILTER_DEFAULT_INPUT_LIST_MAP.COMPOSED_COUNTRY_SELECT,
  FILTER_DEFAULT_INPUT_LIST_MAP.MULTIPLE_AREA_SELECT,
];
